import React, { Dispatch, SetStateAction } from 'react';

// export const Tooltip = dynamic<TooltipProps>( () => import('components/tooltip/Tooltip').then((mod) => mod.Tooltip), { ssr: false } );

/* eslint-disable no-unused-vars */
export enum TooltipPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
  RIGHT = 'right',
  LEFT = 'left',
  BOTTOM_LEFT = 'bottomLeft',
  TOP_CENTER = 'topCenter',
}
/* eslint-enable no-unused-vars */

export type TooltipPositionType = `${TooltipPosition}`;

export type TooltipProps = {
  content: string | undefined;
  iconColor?: string;
  iconId?: string;
  position?: TooltipPositionType;
  children?: string;
  childrenColor?: string;
  stateOnClick?: boolean;
  containerClassName?: string;
  isClicked?: boolean;
  forceActive?: boolean;
  iconClassName?: string;
  setIsClicked?: Dispatch<SetStateAction<boolean>>;
  setStateOnClick?: Dispatch<SetStateAction<boolean>>;
};

export { Tooltip } from './Tooltip';